import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import {
  getPaginatedNodes,
  getPaginationTotalResults,
  toPagination,
} from './utils';
import { PaginationSort, SoftwareFilterInput } from '../gql/graphql';

export const GET_SOFTWARE_LIST = graphql(`
  query getSoftwareList(
    $pagination: PaginationRequest
    $filters: SoftwareFilterInput
    $sort: PaginationSort
  ) {
    softwares(pagination: $pagination, filters: $filters, sort: $sort) {
      edges {
        node {
          uuid
          edition
          language
          part
          product
          type
          update
          version
          source
          score
        }
        cursor
        queryCursor
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export interface IUseSoftwareListQueryArg {
  pageNumber: number;
  pageSize: number;
  sort?: PaginationSort;
  filters?: SoftwareFilterInput;
}
export function useSoftwareListQuery({
  pageNumber,
  pageSize,
  sort,
  filters,
}: IUseSoftwareListQueryArg) {
  const { loading, data, error } = useQuery(GET_SOFTWARE_LIST, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
  });
  const { softwares, totalSoftwares } = useMemo(() => {
    if (loading) {
      return {
        softwares: [],
        totalSoftwares: 0,
      };
    }
    return {
      softwares: getPaginatedNodes(data?.softwares),
      totalSoftwares: getPaginationTotalResults(data?.softwares) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    softwares,
    totalSoftwares,
  };
}
